import * as styles from './index.module.scss';
import React, { useRef } from 'react';

import useIsMobile from '../../../hooks/useIsMobile';

import Marquee from 'react-fast-marquee';

const Index = () => {
  const isMobile = useIsMobile();
  const sliderRef = useRef(null);

  const items = [
    {
      id: 1,
      url: 'https://cdn-web.mtt.xyz/static/Osmosis%20Logo%202.png',
    },
    {
      id: 2,
      url: 'https://cdn-web.mtt.xyz/static/Cosmos%20The%20Internet%20of%20Blockchains%203.png',
    },
    {
      id: 3,
      url: 'https://cdn-web.mtt.xyz/static/Group%201312313988.png',
    },
  ];

  const subItems = [
    {
      id: 4,
      url: 'https://cdn-web.mtt.xyz/static/Group%201312313988.png',
    },
    {
      id: 5,
      url: 'https://cdn-web.mtt.xyz/static/Cosmos%20The%20Internet%20of%20Blockchains%203.png',
    },
    {
      id: 6,
      url: 'https://cdn-web.mtt.xyz/static/Osmosis%20Logo%202.png',
    },
  ];
  return (
    <div className={styles.swiper}>
      <div className={styles.title}>MTT Network Partner</div>

      <Marquee autoFill={true} gradient gradientColor="#020722" loop={0}>
        {items.map((item) => (
          <div key={item.id + 'swiperitem'} className={styles.swiperItem}>
            <img src={item.url}></img>
          </div>
        ))}
      </Marquee>
      {isMobile && (
        <Marquee
          className={styles.subMarquee}
          autoFill={true}
          gradient
          gradientColor="#020722"
          loop={0}
          delay={2}
        >
          {subItems.map((item) => (
            <div key={item.id + 'swiperitem'} className={styles.swiperItem}>
              <img src={item.url}></img>
            </div>
          ))}
        </Marquee>
      )}
    </div>
  );
};

export default Index;
